import React from 'react';
export const EmailFill = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 4.52987e-07H3H3C1.34315 5.2541e-07 0 1.34315 0 3V13C-2.50178e-07 14.6568 1.34315 16 3 16H17C18.6569 16 20 14.6568 20 13V3C20 1.34315 18.6569 0 17 0V4.52987e-07ZM17 2L10.5 6.47C10.1906 6.64863 9.8094 6.64863 9.5 6.47L3 2H17Z",
  fill: "currentColor"
}));